<app-header></app-header>
<div class="outlet-container">
  <router-outlet></router-outlet>
</div>
<div *ngIf="showContactUsIcon" id="contact-us">
  <p-button icon="pi pi-envelope" [rounded]="true" (click)="showDialog()"
            pTooltip="Contact us or report issue"></p-button>
</div>
<app-contact-us *ngIf="showContactUsDialog"></app-contact-us>
<p-toast></p-toast>


